import React, { useState } from 'react'

const Counter = ({ name, defaultValue, onCounterChange, disabled }) => {
    const [count, setCount] = useState(defaultValue);
    
    const incrementCount = () => {
        if (disabled) return; // ✅
        setCount(count + 1);
        onCounterChange(name, count + 1);
    };

    const decrementCount = () => {
        if (disabled) return; // ✅
        if (count > 0) {
            setCount(count - 1);
            onCounterChange(name, count - 1);
        }
    };
  
    return (
        <div className="d-flex items-center js-counter">
            <button
                className="counter-pointer rounded-2 p-0"
                style={{ fontSize: '50px', opacity: disabled ? 0.4 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
                onClick={decrementCount}
            >
                <p className="mb-2 p-0">-</p>
            </button>

            <div className="flex-center d-flex align-items-center text-20 mx-3">
                <div className="text-15 js-count">{count}</div>
            </div>

            <button
                className="counter-pointer rounded-2 p-0"
                style={{ fontSize: '40px', opacity: disabled ? 0.4 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
                onClick={incrementCount}
            >
                <p className="text-16 mb-2 p-0">+</p>
            </button>
        </div>
    );
};

export default Counter